import {i18n} from "@/plugins/i18n";
import StatusColumn from './../components/status-column';

const statusTemplate = (row, index, datatable) => {
    let template = new StatusColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 80,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'cat_name',
        title: i18n.t('label.cat_name'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'user_members',
        title: i18n.t('label.user_members'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'is_deleted',
        title: i18n.t('label.status'),
        sortable: false,
        textAlign: 'center',
        template: (row, index, datatable) => {
          return statusTemplate(row, index, datatable)
        },
    }
]